module.exports = __webpack_public_path__ + "img/unarchive.c26a040d.svg";